import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Header } from './Header';
import { Footer } from './Footer';

export const Layout = ({ children }) => {
  return (
    <Flex direction="column" minH="100vh">
      <Header />
      <Flex direction="column" flex={1}>
        {children}
      </Flex>
      <Footer />
    </Flex>
  );
};
